import { DocumentList } from "@/components/documents/DocumentList";

export default function DocumentsPage({ user }) {
  return <DocumentList user={user} />;
}
